module.exports = __webpack_public_path__ + "img/family.617cf336.svg";